import { useState } from "react";
import {
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Collapse,
  Nav,
  NavItem,
  NavLink,
  Badge,
} from "reactstrap";

import { getSession } from "utils/session";
import "assets/css/Navbar.css";

// Vistas del bot seleccionado: comparten la pestaña Panel
export const BOT_SCREENS = ["matriz", "logs", "grafica"];

const TABS = [
  { key: "bots", label: "Bots", icon: "fas fa-robot", match: ["bots"] },
  { key: "matriz", label: "Panel", icon: "ni ni-chart-bar-32", match: BOT_SCREENS },
  { key: "billing", label: "Comisiones", icon: "ni ni-credit-card", match: ["billing"] },
  { key: "info", label: "Estrategias", icon: "ni ni-books", match: ["info"] },
  { key: "settings", label: "Settings", icon: "ni ni-settings-gear-65", match: ["settings"] },
];

const EmpytNavbar = ({ setScrem, refresh, screm, logout, badges = {} }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const session = getSession();
  const login = session && session.user ? session.user.login : "";

  const select = (key) => {
    setScrem(key);
    setIsOpen(false);
  };

  const onRefresh = async () => {
    setRefreshing(true);
    try {
      await refresh();
    } finally {
      setRefreshing(false);
    }
  };

  return (
    <Navbar className="app-navbar navbar-dark" expand="lg">
      <NavbarBrand href="#" onClick={e => { e.preventDefault(); select("bots"); }}>
        <img alt="logo" src={require("../../assets/img/brand/finanzme.png").default} />
      </NavbarBrand>
      <NavbarToggler onClick={() => setIsOpen(!isOpen)} />

      <Collapse isOpen={isOpen} navbar>
        <Nav navbar>
          {TABS.map(tab => {
            const badge = badges[tab.key];
            return (
              <NavItem key={tab.key}>
                <NavLink
                  href="#"
                  onClick={e => { e.preventDefault(); select(tab.key); }}
                  className={`app-nav-link${tab.match.includes(screm) ? " active" : ""}`}
                >
                  <i className={tab.icon} />
                  {tab.label}
                  {badge && badge.count > 0 && (
                    <Badge color={badge.color} pill title={badge.title}>{badge.count}</Badge>
                  )}
                </NavLink>
              </NavItem>
            );
          })}
        </Nav>

        <div className="app-nav-actions ml-lg-auto">
          {login && (
            <span className="app-nav-user">
              <i className="fas fa-user mr-2" />
              {login}
            </span>
          )}
          <button className="app-nav-button" onClick={onRefresh} disabled={refreshing} title="Actualizar datos">
            <i className={`fas fa-sync-alt${refreshing ? " app-nav-spin" : ""}`} />
            Refrescar
          </button>
          <button className="app-nav-button" onClick={logout} title="Cerrar sesión">
            <i className="fas fa-sign-out-alt" />
            Salir
          </button>
        </div>
      </Collapse>
    </Navbar>
  );
};

export default EmpytNavbar;
